import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Box, Stack, Typography } from '@mui/material';

import { CalendarCheck, UserPlus } from 'lucide-react';

import { AdminAxios as Axios } from '../../Assets/Axios/Axios';

import { ORDER_STATUS } from './../../Constant/Enums';

import { COLORS } from '../../Constant/COLORS';
import { Stagger, StaggerItem } from '../../Components/Motion';

import Card from './Components/Card';

import {
  FindOrdersByOrderStatusAdmin,
  RequestedProfessionalsQueryAdmin,
} from '../../Server/Query';

const Dashboard = () => {
  const navigate = useNavigate();

  const [count, setCount] = useState({
    newOrders: null,
    newProfessionals: null,
  });

  useEffect(() => {
    Promise.all([
      Axios(RequestedProfessionalsQueryAdmin),
      Axios(FindOrdersByOrderStatusAdmin({
          status: ORDER_STATUS.AWAIT_APPROVAL,
        })),
    ])
      .then(([newProfessionalsResponse, newOrdersResponse]) => {
        setCount({
          newProfessionals: newProfessionalsResponse?.errors
            ? 0
            : newProfessionalsResponse?.data?.Professionals?.length ?? 0,
          newOrders: newOrdersResponse?.errors
            ? 0
            : newOrdersResponse?.data?.Orders?.length ?? 0,
        });
      })
      .catch(() => {
        // request failure is already surfaced via the global API error toast;
        // fall back to zeroed counts instead of crashing with an unhandled rejection
        setCount({ newProfessionals: 0, newOrders: 0 });
      });
  }, []);

  return (
    <Box px={{ xs: 2.5, md: 5 }} mt={{ xs: 4, md: 6 }}>
      <Typography variant='overline' color={COLORS.teal} display='block'>
        Overview
      </Typography>
      <Typography variant='h3' mb={0.5}>
        Welcome back
      </Typography>
      <Typography color={COLORS.inkSoft} mb={{ xs: 3, md: 5 }}>
        Here&rsquo;s what needs your attention today.
      </Typography>

      <Stagger>
        <Stack direction='row' gap={{ xs: 3, md: 4 }} flexWrap='wrap'>
          <StaggerItem style={{ flex: '1 1 230px', maxWidth: 300 }}>
            <Card
              label='Booking Request'
              icon={CalendarCheck}
              count={count.newOrders}
              onClick={() => navigate('/admin/booking-request')}
              sx={{ cursor: 'pointer', height: '100%' }}
            />
          </StaggerItem>
          <StaggerItem style={{ flex: '1 1 230px', maxWidth: 300 }}>
            <Card
              label={
                <>
                  Professional <br /> Registration Request
                </>
              }
              icon={UserPlus}
              count={count.newProfessionals}
              onClick={() => navigate('/admin/professionals-request')}
              sx={{ cursor: 'pointer', height: '100%' }}
            />
          </StaggerItem>
        </Stack>
      </Stagger>
    </Box>
  );
};

export default Dashboard;
